import { Component, Input, OnInit } from "@angular/core";
import { PropertyOptions } from "../../../services/property-features.service";

@Component({
  selector: "app-property-features-mx",
  templateUrl: "./property-features-mx.component.html",
  styleUrls: ["./property-features-mx.component.scss"]
})
export class PropertyFeaturesMxComponent implements OnInit {
  @Input() property: any;
  @Input() isMultifamily;
  @Input() customPropertyFeatures: PropertyOptions[] = [];
  listFeatures: any = [];

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      let features = document.getElementById("features");
      this.listFeatures = features?.getElementsByTagName("div");
    }, 1000);
  }
}
